import { render } from "./VsudPaginationItem.vue?vue&type=template&id=5dd145b0&scoped=true"
import script from "./VsudPaginationItem.vue?vue&type=script&lang=js"
export * from "./VsudPaginationItem.vue?vue&type=script&lang=js"

import "./VsudPaginationItem.vue?vue&type=style&index=0&id=5dd145b0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd145b0"]])

export default __exports__